import AlligoLogo from "../assets/alligo-logo.png";
import AvensiaGuyLogo from "../assets/avensia-guy.png";
import AvensiaLogo from "../assets/avensia-logo.png";

const ThemeConfig = {
  projectName: "Alligo Dashboard",
  projectEnvironment: "development", // or "production"
  maxRowsToDownload: 1000,
  jsonMappingFile: "mapping.json",
  jsonMappingBaseFile: "mappingBase.json",
  avensiaLogo: AvensiaLogo,
  alligoLogo: AlligoLogo,
  avensiaGuyLogo: AvensiaGuyLogo,
  defaultTheme: true,
  isOcctooEnable: true,
  isAuth0Enable: true,
  isApprovalEnable: true,

  typography: {
    fontFamily: "'Roboto', sans-serif",
  },

  palette: {
    brand: { orange: "#E94E18", orangeText: "#C2410C", navy: "#0d1117" },
    primary: {
      main: "#0d1117",
      light: "#161b22",
    },
    secondary: {
      main: "#9c27b0",
      light: "#d05ce3",
    },
    contrastText: "#ffffff",
    shell: {
      sidebarBg: "#0d1117",
      sidebarHover: "rgba(255,255,255,0.06)",
      sidebarText: "rgba(255,255,255,0.85)",
      sidebarMuted: "rgba(255,255,255,0.45)",
      accent: "#E94E18",
      contentBg: "#f6f7f9",
    },
    dataGrid: {
      headerTextColor: "#555555",
      pinnedBackground: "#f5f5f5",
      containerBackground: "#ffffff",
    },
  },
};

export default ThemeConfig;
